"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsReact = exports.Terms = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TermsReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TermsReact, _React$Component);
  var _super = _createSuper(TermsReact);
  function TermsReact() {
    (0, _classCallCheck2.default)(this, TermsReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(TermsReact, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        document = _this$props.document,
        siteInfo = _this$props.siteInfo,
        updateFormField = _this$props.updateFormField,
        validateAndSubmit = _this$props.validateAndSubmit;
      var error = document.error,
        isAgreementChecked = document.isAgreementChecked,
        disclosureCopy = document.disclosureCopy,
        pgAppId = document.pgAppId,
        clientId = document.clientId,
        isInterestFree = document.isInterestFree,
        isPRP = document.isPRP;
      var userInfo = siteInfo.userInfo,
        realm = siteInfo.realm;
      var siteAuthorization = userInfo && userInfo.siteAuthorization;
      var errorHTML = error && /*#__PURE__*/_react.default.createElement("div", {
        className: "error"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon icon-form-error error-image"
      }), error);
      var buttonClass = realm && realm === 'LCPS' ? 'lcps-button' : 'yts-button';
      var disclosureText = disclosureCopy && siteAuthorization && disclosureCopy[siteAuthorization] ? disclosureCopy[siteAuthorization] : null;
      var submitBtnText = 'Confirm and Submit';
      var offerPageURL = pgAppId && clientId ? "selectoffer?id=".concat(pgAppId, "&clientId=").concat(clientId) : '';
      var isCheckRequired = isInterestFree || isPRP;
      var bankAgreementCopy = siteAuthorization === 'patient' ? 'I agree that I have reviewed the above application, agree to the Comenity Capital Bank Terms and Conditions, acknowledge receipt of the Comenity Capital Bank Privacy Notice, consent to receive documents electronically, and agree to submit my written application electronically.' : null;
      var changePlanHTML = offerPageURL ? /*#__PURE__*/_react.default.createElement("a", {
        href: offerPageURL
      }, /*#__PURE__*/_react.default.createElement("span", null, "Choose another option")) : '';
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "terms",
        className: "terms"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "agreement"
      }, errorHTML, isCheckRequired && /*#__PURE__*/_react.default.createElement("div", {
        className: "agreement-text"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("input", {
        onClick: updateFormField,
        type: "checkbox",
        checked: isAgreementChecked
      }), bankAgreementCopy, disclosureText)))), /*#__PURE__*/_react.default.createElement("div", {
        className: "navigation"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: validateAndSubmit,
        className: buttonClass
      }, submitBtnText), isCheckRequired && /*#__PURE__*/_react.default.createElement("div", {
        className: "red-text"
      }, "(Credit check required)"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "or"), "\xA0", changePlanHTML)));
    }
  }]);
  return TermsReact;
}(_react.default.Component);
exports.TermsReact = TermsReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    siteInfo: state.siteInfo,
    document: state.document
  };
};
TermsReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired,
  document: _propTypes.default.object.isRequired,
  updateFormField: _propTypes.default.func,
  validateAndSubmit: _propTypes.default.func
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Terms = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TermsReact);
exports.Terms = Terms;
